import { useEffect, useState } from "react";

export const useScreenWidthRange = (min: number, max: number): boolean => {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${min}px) and (max-width: ${max}px)`
    );

    const updateMatch = () => setMatches(mediaQuery.matches);
    updateMatch();

    mediaQuery.addEventListener("change", updateMatch);
    return () => mediaQuery.removeEventListener("change", updateMatch);
  }, [min, max]);

  return matches;
};

export const getBaseUrl = (): string => {
  const host = window.location.hostname;
  if (host.includes("dev")) return "https://dev.app.majura.ai";
  if (host.includes("staging")) return "https://staging.app.majura.ai";
  if (host.includes("localhost")) return "https://dev.app.majura.ai";
  return "https://app.majura.ai";
};
